<script>
import { Line } from 'vue-chartjs'
export default {
  extends: Line,
  name: 'NewRegistrationsGraph',
  created () {
    this.$http.get('/admin/graph/new-registration')
      .then(res => {
        this.renderChart(
          {
            labels: Object.keys(res.data),
            datasets: [
              {
                label: 'Nové registrace',
                data: Object.values(res.data),
                backgroundColor: 'rgba(1, 116, 188, 0.50)',
                borderColor: 'rgba(1, 116, 188, 0.50)',
                pointBackgroundColor: 'rgba(171, 71, 188, 1)'
              }
            ]
          },
          {
            responsive: true,
            maintainAspectRatio: false,
            title: {
              text: 'Nové registrace'
            },
            scales: {
              yAxes: [{
                ticks: {
                  stepSize: 1,
                  reverse: false,
                  beginAtZero: true
                }
              }]
            }
          }
        )
      })
  }
}
</script>

<style scoped>

</style>
